import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useComponentSize from '@rehooks/component-size';
import dt from '../../../shared/theme';

const Container = styled.section`
  clear: both;
  font: ${props => dt(props).theme.fontWeightRegular} 19px/130% ${props => dt(props).theme.fontFamilyBody};

  > div {
    margin: 18px 0 0;
    white-space: pre-line;
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: vertical;
  }

  > div:not(.no-clamp) {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: ${props => props.lines};
  }

  > .link {
    margin-top: 8px;
    font-weight: ${props => dt(props).theme.fontWeightDccc};
    :hover {
      text-decoration: none;
    }
  }
`;

export default function CommentBody({ text }) {
  const measured = React.useRef(false);
  const clampedRef = React.useRef();
  const fullRef = React.useRef();
  const { height: clampedHeight } = useComponentSize(clampedRef);
  const { height: fullHeight } = useComponentSize(fullRef);
  const [expandable, setExpandable] = React.useState(false);
  const [lines, setLines] = React.useState(5);

  React.useLayoutEffect(() => {
    const measureable = fullRef.current;
    const long = measureable && !expandable && fullHeight > clampedHeight;

    if (long) {
      setExpandable(true);
    }
    if (measureable) {
      return () => {
        measured.current = true;
      };
    }
    return () => null;
  }, [clampedHeight, fullHeight, expandable]);

  const expand = evt => {
    evt.preventDefault();
    setExpandable(false);
    setLines('none');
  };

  return (
    <Container lines={lines}>
      <div
        ref={clampedRef}
        className="comment-body"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {!measured.current && (
        <div
          className="no-clamp"
          ref={fullRef}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
      {!!expandable && <a href="#" onClick={expand} className="link">Read More</a>}
    </Container>
  );
}

CommentBody.propTypes = { text: PropTypes.string.isRequired };
